import cryptojs from "crypto-js";

export const encryptbody = async (body: any) => {
  // console.log("incoming body to encrypt", body);
  const encryptedBody = cryptojs.AES.encrypt(
    JSON.stringify(body),
    `${process.env.REACT_APP_EK}`
  ).toString();
  // console.log("encrypted body", encryptedBody);
  return encryptedBody;
};
